import React from "react";
import PropTypes, { object } from "prop-types";
// import moment from "moment";
import { Link } from "react-router";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { setActivePageTitle } from "../actions/settings";
import BonzaTextField from "../components/BonzaTextField";
// import BonzaSelectField from "../components/BonzaSelectField";
import BonzaBooleanField from "../components/BonzaBooleanField";
// import BonzaTourTypeSelect from "../components/BonzaTourTypeSelect";
// import BonzaDatePickerField from "../components/BonzaDatePickerField";
// import LockedPurchaseNotification from "../components/LockedPurchaseNotification";
import config from "../config";
// import axios from "axios";
// import { getCustomerCommission } from "../middleware/api/customers";
// import { getProductTourPricing } from "../middleware/api/products";
// import {
//   getAllotmentsForRange,
//   getAllotmentAvailability,
//   checkIfDateIsBooked,
// } from "../middleware/api/allotments";

// import TableHead from "@material-ui/core/TableHead";
// import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
// import TableCell from "@material-ui/core/TableCell";
import IconButton from "@material-ui/core/IconButton";
import CircularProgress from "@material-ui/core/CircularProgress";
// import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Snackbar from "@material-ui/core/Snackbar";
import Button from "@material-ui/core/Button";
// import Divider from "@material-ui/core/Divider";
// import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import SearchIcon from "@material-ui/icons/Search";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import CloseIcon from "@material-ui/icons/Close";
import CheckIcon from "@material-ui/icons/Check";
import InfoIcon from "@material-ui/icons/Info";
import DirectionsBikeIcon from "@material-ui/icons/DirectionsBike";
// import { requestProductPriceUpdate } from "../actions/product";
// import spacing from "@material-ui/core/styles/spacing";

// import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
// import FormControlLabelWrapper from "../components/FormControlLabelWrapper";
// import { requestPurchases } from "../actions/purchase";

import {
  createEquipmentPurchase,
  getEquipmentPurchaseForTour,
  updateEquipmentPurchase,
  getTourPurchase,
  getEquipmentInventory,
  deleteEquipmentPurchase,
} from "../middleware/api/purchases";
import { TableHeaderColumn } from "material-ui";

// const OVERRIDE_INVENTORY = true;

const styles = (theme) => ({
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
});

const noMargin = { marginBottom: `0px` };

const initialState = {
  addEquipmentSectionCollapsed: false,
  tourPurchaseSectionCollapse: true,
  purchaseWasCreated: false,
  updateMode: false,
  
  loading: false,
  bookingIDExists: false,
  bookingID: "",
  showDetails: false,
  locked: false,
  status: config.statuses[0],
  totalInventory: false,
  equipmentPurchaseID: null,

  travelerFirstname: "",
  travelerLastname: "",
  
  totalRiders: 0,
  family: 0,

  noOfFamilyGroups: 0,
  familyRate: 0,
  noOfAdditionals: 0,
  additionalRate: 0,
  noOfAddChildren: 0,
  noOfAddAdult: 0,

  noOfAdult: 0,
  noOfChildren: 0,
  noOfBabies: 0,

  noOfEBikes: 0,
  noOfBabySeats: 0,
  noOfTrailAlongs: 0,
  noOfKiddieCarriers: 0,
  noOfSmallKidsBikes: 0,
  noOfLargeKidsBikes: 0,
  equipmentList : null,

  noOfEBikesTour: 0,
  noOfBabySeatsTour: 0,
  noOfTrailAlongsTour: 0,
  noOfKiddieCarriersTour: 0,
  noOfSmallKidsBikesTour: 0,
  noOfLargeKidsBikesTour: 0,

  eBikePrice: 0,
  babySeatPrice: 0,
  trailAlongPrice: 0,
  kiddieCarrierPrice: 0,
  smallKidsBikePrice: 0,
  largeKidsBikePrice: 0,
  totalEquipmentCost: 0,
  overrideEquipmentCount: 0,
  tourDate: null,

  tourInActive: true,
  allowDelete: true,

  validationErrors: [],
};

const fieldMappings = {
  noOfEBikes: ["noOfEBikesTour", "eBikePrice"],
  noOfBabySeats: ["noOfBabySeatsTour", "babySeatPrice"],
  noOfTrailAlongs: ["noOfTrailAlongsTour", "trailAlongPrice"],
  noOfKiddieCarriers: ["noOfKiddieCarriersTour", "kiddieCarrierPrice"],
  noOfSmallKidsBikes: ["noOfSmallKidsBikesTour", "smallKidsBikePrice"],
  noOfLargeKidsBikes: ["noOfLargeKidsBikesTour", "largeKidsBikePrice"]
};

class EquipmentPurchasePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialState;

    this.togglePanel = this.togglePanel.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleShowDetails = this.handleShowDetails.bind(this);
    this.setValueOfAdultEquipments = this.setValueOfAdultEquipments.bind(this);
    this.setValueOfInfantEquipments = this.setValueOfInfantEquipments.bind(this);
    this.setValueOfKidEquipments = this.setValueOfKidEquipments.bind(this);
    this.setValue = this.setValue.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.onDeleteEquipmentPurchase = this.onDeleteEquipmentPurchase.bind(this);
    this.onFormSubmitAndTakePayment = this.onFormSubmitAndTakePayment.bind(this);
    this.resetEquipmentOverride = this.resetEquipmentOverride.bind(this);

    if (props.params.id) {
      props.dispatch(setActivePageTitle(`Edit Equipment purchase`));
      this.search(props.params.id);
    } else {
      props.dispatch(setActivePageTitle(`Add Equipment purchase`));
    }
  }
  
  setTotalEquipmentCost() {
    this.state.totalEquipmentCost =
      this.state.noOfEBikes * this.state.eBikePrice +
      this.state.noOfBabySeats * this.state.babySeatPrice +
      this.state.noOfTrailAlongs * this.state.trailAlongPrice +
      this.state.noOfKiddieCarriers * this.state.kiddieCarrierPrice +
      this.state.noOfSmallKidsBikes * this.state.smallKidsBikePrice +
      this.state.noOfLargeKidsBikes * this.state.largeKidsBikePrice;

    console.log(
      "INSIDE setTotalEquipmentCost: " +
        this.state.noOfEBikes +
        " : " +
        this.state.eBikePrice,
    );
    console.log(
      "INSIDE setTotalEquipmentCost: " +
        this.state.noOfBabySeats +
        " : " +
        this.state.babySeatPrice,
    );
    console.log(
      "INSIDE setTotalEquipmentCost: " +
        this.state.noOfTrailAlongs +
        " : " +
        this.state.trailAlongPrice,
    );
    console.log(
      "INSIDE setTotalEquipmentCost: " +
        this.state.noOfKiddieCarriers +
        " : " +
        this.state.kiddieCarrierPrice,
    );
    console.log(
      "INSIDE setTotalEquipmentCost: " +
        this.state.noOfSmallKidsBikes +
        " : " +
        this.state.smallKidsBikePrice,
    );
    console.log(
      "INSIDE setTotalEquipmentCost: " +
        this.state.noOfLargeKidsBikes +
        " : " +
        this.state.largeKidsBikePrice,
    );

    console.log("totalEquipmentCost: " + this.state.totalEquipmentCost);
    return this.state.totalEquipmentCost;
  }

  getTotalRiders(stateCopy) {
    let total = 0,
    sum = 0;
    console.log("INSIDE getTotalRiders: stateCopy.family = " + stateCopy.family);

    if (stateCopy.family === 0) {
      total = stateCopy.noOfAdult + stateCopy.noOfChildren;
      sum =
        stateCopy.noOfAdult * stateCopy.adultPrice +
        stateCopy.noOfChildren * stateCopy.childPrice;
    } else {
      console.log("INSIDE getTotalRiders ELSE");
      total =
        stateCopy.noOfFamilyGroups * 4 +
        stateCopy.noOfAddAdult +
        stateCopy.noOfAddChildren;

      console.log(" stateCopy.noOfFamilyGroups: " + stateCopy.noOfFamilyGroups);
      console.log(" stateCopy.noOfAddAdult: " + stateCopy.noOfAddAdult);
      console.log(" stateCopy.noOfAddChildren: " + stateCopy.noOfAddChildren);
      sum =
        stateCopy.noOfFamilyGroups * stateCopy.familyRate +
        stateCopy.noOfAddAdult * stateCopy.additionalRate +
        stateCopy.noOfAddChildren * stateCopy.additionalRate;
    }

    return { total, sum };
  }

  resetEquipmentOverride(name, value) {
    this.setState({ [name]: value });
    console.log("resetEquipmentOverride called: " + value);
    if (value === 0) {
      this.setValue("noOfEBikes", 0);
      this.setValue("noOfBabySeats", 0);
      this.setValue("noOfTrailAlongs", 0);
      this.setValue("noOfKiddieCarriers", 0);
      this.setValue("noOfSmallKidsBikes", 0);
      this.setValue("noOfLargeKidsBikes", 0);
    }
  }

  setValue(name, value) {
    this.setState({ [name]: value });
  }

  checkEquipmentInventory (fieldName, value, equipmentName, inventoryFieldName, errMsg, 
            numberOfPax, newEquipmentCount) {
    let totalBooked =  this.state.totalInventory[`${inventoryFieldName}`] ? 
                          parseInt(this.state.totalInventory[`${inventoryFieldName}`].totalBooked) : 0;
    let totalInventory =  this.state.totalInventory[`${inventoryFieldName}`].totalInventory ? 
                            parseInt(this.state.totalInventory[`${inventoryFieldName}`].totalInventory) : 0;
    let overBooking = totalBooked  + value - totalInventory;
    let newErrMsg = errMsg;
    let showErrorMessage = false;

    console.log("newEquipmentCount : " + newEquipmentCount);
    if (!this.state.overrideEquipmentCount && (overBooking > 0)) {
      showErrorMessage = true;

      if (newEquipmentCount > numberOfPax) {
        newErrMsg = "ERROR: The number of " + `${equipmentName}` + " you requested exceed the number of " +`${equipmentName}` + " available in the inventory for the day/tour. Also " + errMsg;
      } else {
        newErrMsg = "ERROR: The number of " + `${equipmentName}` + " you requested exceed the number of " +`${equipmentName}` + " available in the inventory for the day/tour."
      }
    } else {
      if (newEquipmentCount <= numberOfPax) {
        this.setState({ [fieldName]: value }, this.totalRider);
        if (overBooking > 0) {
          showErrorMessage = true;
          newErrMsg = "WARNING: The number of " + `${equipmentName}` + " you requested exceed the number of " +`${equipmentName}` + " available in the inventory for the day/tour."
        }
      } else {
        showErrorMessage = true;
        newErrMsg = "ERROR: " + errMsg;
      }
    }

    return [showErrorMessage, newErrMsg];
  }

  setValueOfAdultEquipments(name, value) {
    let showErrorMessage = false;
    let numberOfAddAdults = this.state.noOfAddAdult;
    let numberOfAdults = this.state.noOfAdult;
    let numberOfEBikes = this.state.noOfEBikes;
    let numberOfFamilyGroups = this.state.noOfFamilyGroups;
    let errMsg = "e-Bikes are only available for adults at this time. The number of e-bikes you have added to the booking exceed the number of adults in the booking.";

    if (name === "noOfEBikes") {
      numberOfEBikes = value;
    } else if (name === "noOfFamilyGroups") {
      numberOfFamilyGroups = value;
      this.setValueOfKidEquipments(name, value);
    } else if (name === "noOfAddAdult") {
      numberOfAddAdults = value;
    } else if (name === "noOfAdult") {
      numberOfAdults = value;
    }

    if (numberOfFamilyGroups > 0) {
      numberOfAdults = numberOfFamilyGroups * 2 + numberOfAddAdults;
    }

    if (name === "noOfEBikes") {
      let totalEquipmentCount = this.state.noOfEBikesTour + numberOfEBikes;
      console.log("numberOfAdults : " + numberOfAdults + ", numberOfEBikes: " + numberOfEBikes + 
                          ", totalEquipmentCount: " + totalEquipmentCount);
  
      [showErrorMessage, errMsg] = this.checkEquipmentInventory (name, value, "e-bikes", "eBikeInventory", errMsg, 
            numberOfAdults, totalEquipmentCount);
    } else {
      if (name === "noOfAddAdult") {
        if (numberOfFamilyGroups > 0) {
          this.setState({ [name]: value }, this.totalRider);
        } else {
          this.setState((state) => {
            return {
              ...state,
              validationErrors: [
                "Additional adult can be added only after adding a Family Group.",
              ],
            };
          });
        }
      } else {
        this.setState({ [name]: value }, this.totalRider);
      }

      if (numberOfEBikes > numberOfAdults) {
        this.setValue("noOfEBikes", numberOfAdults);
        showErrorMessage = true;
        errMsg = "ERROR: " + errMsg;
      }
    }

    if (showErrorMessage === true) {
      this.setState((state) => {
        return {
          ...state,
          validationErrors: [
            errMsg
          ],
        };
      });
    }
  }

  setValueOfInfantEquipments(name, value) {
    let showErrorMessage = false;
    let numberOfBabies = this.state.noOfBabies;
    let numberOfBabySeats = this.state.noOfBabySeats;
    let errMsg = "Baby seats are only available for Infants at this time. The number of baby seats you add to the booking can't be more than the number of infants in the booking.";

    if (name === "noOfBabies") {
      numberOfBabies = value;
      this.setState({ [name]: value }, this.totalRider);

      if (numberOfBabySeats > numberOfBabies) {
        this.setValue("noOfBabySeats", numberOfBabies);
        showErrorMessage = true;
        errMsg = "ERROR: " + errMsg;
      }
    } else if (name === "noOfBabySeats") {
      numberOfBabySeats = value;

      let totalEquipmentCount = this.state.noOfBabySeatsTour + numberOfBabySeats;
      console.log("numberOfBabies : " + numberOfBabies + ", numberOfBabySeats: " + numberOfBabySeats + 
                          ", totalEquipmentCount: " + totalEquipmentCount);   

      [showErrorMessage, errMsg] = this.checkEquipmentInventory (name, value, "baby seats", "babySeatInventory", errMsg, 
              numberOfBabies, totalEquipmentCount);
    }

    console.log("numberOfBabies : " + numberOfBabies + ", numberOfBabySeats: " + numberOfBabySeats);

    if (showErrorMessage === true) {
      this.setState((state) => {
        return {
          ...state,
          validationErrors: [
            errMsg
          ],
        };
      });
    }
  }

  setValueOfKidEquipments(name, value) {
    let showErrorMessage = false;

    let numberOfFamilyGroups = this.state.noOfFamilyGroups;
    let numberOfAddChildren = this.state.noOfAddChildren;
    let numberOfChildren = this.state.noOfChildren;
    let numberOfTrailAlongs = this.state.noOfTrailAlongs;
    let numberOfKiddieCarriers = this.state.noOfKiddieCarriers;
    let numberOfSmallKidsBikes = this.state.noOfSmallKidsBikes;
    let numberOfLargeKidsBikes = this.state.noOfLargeKidsBikes;
    let totalKidsEquipments = 0;
    let errMsg = "Kids equipments are only available for kids at this time. The number of kid equipments you add to the booking can't be more than the number of kids (excluding infants) in the booking.";

    if (name === "noOfTrailAlongs") {
      numberOfTrailAlongs = value;
    } else if (name === "noOfKiddieCarriers") {
      numberOfKiddieCarriers = value;
    } else if (name === "noOfSmallKidsBikes") {
      numberOfSmallKidsBikes = value;
    } else if (name === "noOfLargeKidsBikes") {
      numberOfLargeKidsBikes = value;
    } else if (name === "noOfAddChildren") {
      numberOfAddChildren = value;
    } else if (name === "noOfChildren") {
      numberOfChildren = value;
    } else if (name === "noOfFamilyGroups") {
      numberOfFamilyGroups = value;
    }

    if (numberOfFamilyGroups > 0) {
      numberOfChildren = numberOfFamilyGroups * 2 + numberOfAddChildren;
    }

    totalKidsEquipments = numberOfTrailAlongs + numberOfKiddieCarriers + numberOfSmallKidsBikes + numberOfLargeKidsBikes;

    let totalKidsEquipmentsAlreadyBooked = this.state.noOfTrailAlongsTour + this.state.noOfKiddieCarriersTour +
              this.state.noOfSmallKidsBikesTour + this.state.noOfLargeKidsBikesTour;
    let totalEquipmentCount = totalKidsEquipments + totalKidsEquipmentsAlreadyBooked;
    console.log("numberOfChildren : " + numberOfChildren + ", totalKidsEquipments : " + totalKidsEquipments +
            ", totalKidsEquipmentsAlreadyBooked: " + totalKidsEquipmentsAlreadyBooked + ", totalEquipmentCount: " + totalEquipmentCount);   

    switch (name) {
      case "noOfTrailAlongs":
        [showErrorMessage, errMsg] = this.checkEquipmentInventory (name, value, "trail alongs", "trailAlongInventory", errMsg, 
                  numberOfChildren, totalEquipmentCount);
        break;
      case "noOfKiddieCarriers":
        [showErrorMessage, errMsg] = this.checkEquipmentInventory (name, value, "kiddie carriers", "kiddieCarrierInventory", errMsg, 
                  numberOfChildren, totalEquipmentCount);
        break;
      case "noOfSmallKidsBikes":
        [showErrorMessage, errMsg] = this.checkEquipmentInventory (name, value, "small kids bikes", "smallKidsBikeInventory", errMsg, 
                  numberOfChildren, totalEquipmentCount);
        break;
      case "noOfLargeKidsBikes":
        [showErrorMessage, errMsg] = this.checkEquipmentInventory (name, value, "large kids bikes", "largeKidsBikeInventory", errMsg, 
                  numberOfChildren, totalEquipmentCount);
        break;
      case "noOfAddChildren":
        if (numberOfFamilyGroups > 0) {
          this.setState({ [name]: value }, this.totalRider);
          if (totalKidsEquipments > numberOfChildren) {
            if (numberOfTrailAlongs > 0) {
              this.setValue("noOfTrailAlongs", numberOfTrailAlongs - 1);
            } else if (numberOfKiddieCarriers > 0) {
              this.setValue("noOfKiddieCarriers", numberOfKiddieCarriers - 1);
            } else if (numberOfSmallKidsBikes > 0) {
              this.setValue("noOfSmallKidsBikes", numberOfSmallKidsBikes - 1);
            } else if (numberOfLargeKidsBikes > 0) {
              this.setValue("noOfLargeKidsBikes", numberOfLargeKidsBikes - 1);
            }
            showErrorMessage = true;
            errMsg = "ERROR: " + errMsg;
          }
        } else {
          this.setState((state) => {
            return {
              ...state,
              validationErrors: [
                "Additional child can be added only after adding a Family Group.",
              ],
            };
          });
        }
        break;
      case "noOfChildren":
        this.setState({ [name]: value }, this.totalRider);

        if (totalKidsEquipments > numberOfChildren) {
          if (numberOfTrailAlongs > 0) {
            this.setValue("noOfTrailAlongs", numberOfTrailAlongs - 1);
          } else if (numberOfKiddieCarriers > 0) {
            this.setValue("noOfKiddieCarriers", numberOfKiddieCarriers - 1);
          } else if (numberOfSmallKidsBikes > 0) {
            this.setValue("noOfSmallKidsBikes", numberOfSmallKidsBikes - 1);
          } else if (numberOfLargeKidsBikes > 0) {
            this.setValue("noOfLargeKidsBikes", numberOfLargeKidsBikes - 1);
          }
          showErrorMessage = true;
          errMsg = "ERROR: " + errMsg;
        }

        break;
      case "noOfFamilyGroups":
        if (totalKidsEquipments > numberOfChildren) {
          this.setValue("noOfTrailAlongs", 0);
          this.setValue("noOfKiddieCarriers", 0);
          this.setValue("noOfSmallKidsBikes", 0);
          this.setValue("noOfLargeKidsBikes", 0);
          showErrorMessage = true;
          errMsg = "ERROR: " + errMsg;
        }
        if (numberOfFamilyGroups === 0) {
          this.setValue("noOfAddAdditionals", 0);
          this.setValue("noOfAddAdult", 0);
          this.setValue("noOfEBikes", 0);
          this.setValue("noOfBabies", 0);
          this.setValue("noOfBabySeats", 0);
          this.setValue("noOfAddChildren", 0);
          this.setValue("noOfTrailAlongs", 0);
          this.setValue("noOfKiddieCarriers", 0);
          this.setValue("noOfSmallKidsBikes", 0);
          this.setValue("noOfLargeKidsBikes", 0);
        }

      default:
        break;
    }

    if (showErrorMessage === true) {
      this.setState((state) => {
        return {
          ...state,
          validationErrors: [
            errMsg
          ],
        };
      });
    }
  }

  togglePanel(name) {
    if (name in this.state === false) {
      throw new Error(`Invalid panel name ${name}`);
    }

    this.setState({ [name]: !this.state[name] });
  }

  handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({
      validationErrors: [],
    });
  };
  onSearchClick = () => {
    const { bookingID } = this.state;
    this.search(bookingID);
  };

  onFormSubmitAndTakePayment() {
    this.onFormSubmit(true);
  }

  onDeleteEquipmentPurchase() {
    if (confirm('WARNING: **The delete is permenant and cannot be undone ** \n\nAre you sure you want to delete the equipment puchase?')) {
      this.setState({ loading: true });
      deleteEquipmentPurchase(this.state.equipmentPurchaseID).then(() => {
          this.setState({ loading: false });
          this.props.router.push(`/`);
        })
        .catch((error) => {
          console.error(error);
          console.log("request : " + error.request);
          console.log("msg: " + error.message);
          this.setState({
            loading: false,
            validationErrors: [`Error occured while deleting the equipment purchase. Check if there are any assocaited payments.`],
          });
        });
    } else {
      console.log("Delete Cancelled!");
    }
  }

  validate () {
    return new Promise((resolve, reject) => {
      let errors = [`At least one equipment needs to be added`];
      let totalEquipments = 0;

      for (const equipment of Object.keys(this.state.equipmentList)) {
        let priceFieldName = fieldMappings[equipment][1];

        totalEquipments += this.state[equipment];
      }

      if (totalEquipments === 0) {
        reject(errors);
      } else {
        resolve();
      }

    });
  }

  onFormSubmit(payAfterwards = false) {
    this.setState({ loading: true });

    this.validate().then(() => {
      let equipmentInfo = {};
      for (const equipment of Object.keys(this.state.equipmentList)) {
        let priceFieldName = fieldMappings[equipment][1];

        equipmentInfo[equipment] = {quantity : this.state[equipment], [priceFieldName] : this.state[priceFieldName]};
      }

      console.log("this.state.tourDate: " + this.state.tourDate);

      if (this.state.equipmentPurchaseID == null) {
        let equipmentData = {
          tourPurchaseId: this.state.bookingID,
          tourDate: this.state.tourDate,
          equipmentMap: equipmentInfo,
        };

        createEquipmentPurchase(equipmentData).then((equipmentPurchaseID) => {
            this.setValue("purchaseWasCreated", true);
            this.setValue("equipmentPurchaseID", equipmentPurchaseID["equipmentPurchaseID"]);

            if (payAfterwards === true) {
              console.log("navigate to payment");

              this.props.router.push(`/purchases/${this.state.equipmentPurchaseID}/payment`);
            }
        })
        .catch(() => {
            this.setState({
                loading: false,
                validationErrors: [`Error occurred while creating purchase. Check if the tour is active`],
            });
        });
      } else {
        let equipmentData = {
          tourPurchaseId: this.state.bookingID,
          equipmentPurchaseID: this.state.equipmentPurchaseID,
          tourDate: this.state.tourDate,
          equipmentMap: equipmentInfo,
        };
    
        updateEquipmentPurchase(equipmentData).then((equipmentPurchaseID) => {
            this.setValue("purchaseWasCreated", true);
        })
        .catch(() => {
            this.setState({
                loading: false,
                validationErrors: [`Error occurred while updating purchase. Check if the tour is active`],
            });
        });
      }
    })
    .catch((validationErrors) => {
      console.log(validationErrors);
      this.setState({
        loading: false,
        validationErrors: Array.isArray(validationErrors)
          ? validationErrors
          : [validationErrors],
      });
    });
  }

    search(id) {
      this.setState(initialState);
      // this.setValue("bookingID",id);
      getTourPurchase(id).then((tourPurchase) => {
          // Normalizing integer values
          const integerFields = [
            "noOfFamilyGroups",
            "noOfAdditionals",
            "noOfAddChildren",
            "noOfAddAdult",
            "noOfAdult",
            "noOfChildren",
            "noOfBabies",
            "family"
          ];
          const integerStateUpdates = {};
          integerFields.forEach((item) => {
            integerStateUpdates[item] =
              tourPurchase[item] === "" ? 0 : parseInt(tourPurchase[item]);
          });
  
          // Normalizing float values
          const floatFields = [
            "familyRate",
            "additionalRate",
            "adultPrice",
            "childPrice",
            "totalGross",
            "commission",
            "commissionLevel",
            "totalNet",
            "discountedAmount",
            "eBikePrice",
            "babySeatPrice",
            "trailAlongPrice",
            "kiddieCarrierPrice",
            "smallKidsBikePrice",
            "largeKidsBikePrice",
            "totalEquipmentCost",
          ];
          const floatStateUpdates = {};
          floatFields.forEach((item) => {
            floatStateUpdates[item] =
              tourPurchase[item] === "" ? 0 : parseFloat(tourPurchase[item]);
          });
    
          const stateUpdates = {};
    
          for (let field in fieldMappings) {
            if (tourPurchase.hasOwnProperty(field)) {
              const stateField = fieldMappings[field][0];
              console.log("field: " + field + " fieldMappings[field][0] : " + fieldMappings[field][0]);
              if (stateField) {
                stateUpdates[stateField] = (tourPurchase[field] === "") ? 0 : parseInt(tourPurchase[field]);
              }
            }
          }
          let requestedDate = tourPurchase["tourDate"].slice(0, 10);

          let travelerFirstname = String(tourPurchase["travelerFirstname"]);
          let travelerLastname = String(tourPurchase["travelerLastname"]);

          let tourInActiveLocal = true;
          let allowDeleteLocal = true;
          let tourStatusLocal = tourPurchase.status;
          console.log("tourStatusLocal: " + tourStatusLocal);
          if (tourStatusLocal == 'active') {
            tourInActiveLocal = false;
          } else {
            allowDeleteLocal = false;
          }
          console.log("tourInActiveLocal: " + tourInActiveLocal);
          console.log("allowDeleteLocal: " + allowDeleteLocal);
  
          const updatedInitialState = {
            ...integerStateUpdates,
            ...floatStateUpdates,
            ...stateUpdates,
            bookingIDExists: false,
            tourDate: requestedDate,
            travelerFirstname: travelerFirstname,
            travelerLastname: travelerLastname,
            bookingID: id, 
            tourInActive: tourInActiveLocal,
            allowDelete: allowDeleteLocal,
            status: tourStatusLocal,
            equipmentList : {
              "noOfEBikes" : 1001,
              "noOfBabySeats": 1002,
              "noOfTrailAlongs": 1003,
              "noOfKiddieCarriers": 1004,
              "noOfSmallKidsBikes": 1005,
              "noOfLargeKidsBikes": 1006,
            } 
          };

          this.setState(updatedInitialState);
          this.state.totalRiders = this.getTotalRiders(tourPurchase).total;
          console.log("totalRiders: " + this.state.totalRiders);

          console.log(
            "WILLMOUNT: " + this.state.noOfEBikes + " : " + this.state.eBikePrice,
          );
          console.log(
            "WILLMOUNT: " +
              this.state.noOfBabySeats +
              " : " +
              this.state.babySeatPrice,
          );
          console.log(
            "WILLMOUNT: " +
              this.state.noOfTrailAlongs +
              " : " +
              this.state.trailAlongPrice,
          );
          console.log(
            "WILLMOUNT: " +
              this.state.noOfKiddieCarriers +
              " : " +
              this.state.kiddieCarrierPrice,
          );
          console.log(
            "WILLMOUNT: " +
              this.state.noOfSmallKidsBikes +
              " : " +
              this.state.smallKidsBikePrice,
          );
          console.log(
            "WILLMOUNT: " +
              this.state.noOfLargeKidsBikes +
              " : " +
              this.state.largeKidsBikePrice,
          );

          getEquipmentPurchaseForTour(id).then((prevEquipmentPurchase) => {
            if (prevEquipmentPurchase === "DoesNotExist") {
              console.log("Does Not Exist");
            } else {
              console.log("equipmentList : " + updatedInitialState.equipmentList);

              if (prevEquipmentPurchase.purchaseID) {
                this.state.equipmentPurchaseID = prevEquipmentPurchase.purchaseID;
              }

              // Setprice as saved in equipment purchase
              const equipmentPriceFields = [
                "eBikePrice",
                "babySeatPrice",
                "trailAlongPrice",
                "kiddieCarrierPrice",
                "smallKidsBikePrice",
                "largeKidsBikePrice"
              ];

              equipmentPriceFields.forEach((item) => {
                let price = prevEquipmentPurchase[item] === "" ? 0 : parseFloat(prevEquipmentPurchase[item]);
                console.log("item: " + item +  ", price: " + price);

                this.setValue(item, price);
              });

              for (const equipment of Object.keys(updatedInitialState.equipmentList)) {
                console.log("equipment : " + equipment);

                const quantity = prevEquipmentPurchase[equipment] ? prevEquipmentPurchase[equipment] : 0;

                console.log("name: " + equipment + ", quantity: " + quantity);
                this.setValue(equipment, quantity);
              }
            }

            // Get Inventory Consumption
            getEquipmentInventory(updatedInitialState.tourDate.toString()).then((availableInventory) => {
              this.setValue('totalInventory', availableInventory);

              console.log("totalInventory['largeKidsBikeInventory'].totalBooked: " + this.state.totalInventory['largeKidsBikeInventory'].totalBooked);
              console.log("totalInventory['largeKidsBikeInventory'].totalInventory: " + this.state.totalInventory['largeKidsBikeInventory'].totalInventory);

              // All data fetched from backend. Show the UI
              this.setState({ bookingIDExists: true });
            }).catch((err) => {
                console.log(id);
                this.setState({
                    loading: false,
                    validationErrors: [
                      `Unable to get equipment inventory`,
                    ],
                    bookingIDExists: false,
                });                
            });
         }).catch((err) => {
              console.log(id);
              this.setState({
                  loading: false,
                  validationErrors: [
                    `Unable to get equipment purchase for Tour with identifier ${id}`,
                  ],
                  bookingIDExists: false,
              });
        });
        
        }).catch(() => {
            console.log(id);
            this.setState({
                loading: false,
                validationErrors: [
                  `Unable to get the purchase with identifier ${id}`,
                ],
                bookingIDExists: false,
            });
        });
    }
  
  handleShowDetails = () => {
    this.setState({ showDetails: !this.state.showDetails });
  };

  render() {
    let panelHeaderStyle = {
      backgroundColor: `rgb(30, 136, 229)`,
      color: `white`,
    };
    let t= 0;
    let overlay = false;
    if (this.state.loading) {
      let overlayContent = (
        <div
          style={{
            top: `50%`,
            position: `absolute`,
            left: `50%`,
          }}
        >
          <CircularProgress />
        </div>
      );

      if (this.state.purchaseWasCreated) {
        let text = (
          <p>
            Equipment purchase was created
          </p>
        );
        let link = (
          <div>
            <p>
              <Link
                to={`/purchases/${this.state.equipmentPurchaseID}/payment`}
                className="no-underline"
              >
                <Button variant="contained" size="small">
                  Take payment
                </Button>
              </Link>
            </p>
            <p>
              <Button
                variant="contained"
                className="button-orange"
                  onClick={() => {
                    this.setState({
                      loading: false,
                    });
                  }}
              >
                Add another equipment purchase
              </Button>
            </p>
            <p>
              <Link to="/" className="no-underline">
                <Button variant="contained" color="primary">
                  Back to home
                </Button>
              </Link>
            </p>
          </div>
        );

        overlayContent = (
          <div
            style={{
              top: `calc(40% - 80px)`,
              left: `calc(50% - 80px)`,
              position: `fixed`,
              textAlign: `center`,
            }}
          >
            <CheckIcon color="primary" style={{ fontSize: 80 }} />
            <br />
            {text}
            {link}
          </div>
        );
      }

      overlay = (
        <div
          style={{
            position: `absolute`,
            width: `100%`,
            height: `100%`,
            backgroundColor: `rgba(255,255,255,0.6)`,
            zIndex: `100`,
          }}
        >
          {overlayContent}
        </div>
      );
    }

    return (
      <div>
        {overlay}
      <div>
      <div style={{ display: `flex` }}>
        <div style={{ paddingRight: `10px`, paddingTop: `4px`, paddingLeft: `16px` }}>
          <FormLabel>Bonza Booking ID</FormLabel>
        </div>
        <div style={{ paddingRight: `0px` }}>
          <TextField
            value={this.state.bookingID}
            onChange={(event) => {
              const value = event.target.value;
              this.setState({ bookingID: value });
            }}
          />
        </div>
        <Button
          size="small"
          variant="contained"
          color="primary"
          onClick={this.onSearchClick}
          style={{ marginLeft: `10px` }}
        >
          <SearchIcon className={this.props.classes.leftIcon} />
          Search
        </Button>

        {this.state.tourInActive === true ? (
          <div>
              <Typography variant="subtitle1" style={{ padding: `0px 0px 0px 20px`, color: `#FF0000` }}>
                WARNING: This booking is not active. Please activate to add/update/delete equipment purchase.
              </Typography>
          </div>
        ) : (
          false
        )}
      </div>
      <div style={{ margin: `1rem` }}>
              {this.state.bookingIDExists ? (
          <div>
            <ExpansionPanel
              expanded={!this.state.tourPurchaseSectionCollapse}
              onChange={() => {
                this.togglePanel(`tourPurchaseSectionCollapse`);
              }}
            >
              <ExpansionPanelSummary
                expandIcon={<ExpandMoreIcon style={{ color: `white` }} />}
                style={panelHeaderStyle}
              >
                <div>
                  <div style={{ float: `left`, paddingRight: `10px` }}>
                    <InfoIcon />
                  </div>{" "}
                  Tour Purchase Details
                </div>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <div style={{ width: `100%` }}>
                  <div className="row">
                    <div
                      className="col-xs-12 col-sm-6 col-md-6 col-lg-4 m-b-15"
                      style={noMargin}
                    >
                      <BonzaTextField
                        title="Lead traveller last name"
                        value= {this.state.travelerLastname}
                        fullWidth={true}
                        name="travelerLastname"
                        disabled= 'true'
                      />
                    </div>
                    <div
                      className="col-xs-12 col-sm-6 col-md-6 col-lg-4 m-b-15"
                      style={noMargin}
                    >
                      <BonzaTextField
                        title="Lead traveller first name"
                        fullWidth={true}
                        value={this.state.travelerFirstname}
                        name="travelerFirstname"
                        disabled= 'true'
                      />
                    </div>
                    </div>
                    <div className="row">
                      <div
                        className="col-xs-12 col-sm-6 col-md-6 col-lg-4 m-b-15"
                        style={noMargin}
                      >
                        <BonzaTextField
                          title="Tour Date"
                          value={this.state.tourDate}
                          name="tourDate"
                          disabled= 'true'
                        />
                      </div>
                      <div
                        className="col-xs-12 col-sm-6 col-md-6 col-lg-4 m-b-15"
                        style={noMargin}
                      >
                        <BonzaTextField
                          title="Status"
                          value={this.state.status}
                          name="Status"
                          disabled= 'true'
                        />
                      </div>
                    </div>
                    <div className="row">
                        <div
                          className="col-xs-12 col-sm-6 col-md-6 col-lg-4 m-b-15"
                          style={noMargin}
                        >
                          <BonzaBooleanField
                            title="Family booking"
                            disabled= 'true'
                            value={this.state.family}
                            name="family"
                            // onChange={this.resetPaxSelection}
                          />
                        </div>
                      </div>

                      {this.state.family === 1 ? (
                        <div>
                          <div className="row">
                            <div
                              className="col-xs-12 col-sm-6 col-md-6 col-lg-4 m-b-15"
                              style={noMargin}
                            >
                              <BonzaTextField
                                title="Family groups"
                                type="number"
                                value={this.state.noOfFamilyGroups}
                                name="noOfFamilyGroups"
                                disabled= 'true'
                                // onChange={this.setValueOfAdultEquipments}
                              />
                            </div>
                            <div
                              className="col-xs-12 col-sm-6 col-md-6 col-lg-4 m-b-15"
                              style={noMargin}
                            >
                              <BonzaTextField
                                title="Family rate ($)"
                                type="number"
                                value={this.state.familyRate}
                                name="familyRate"
                                disabled= 'true'
                                // onChange={this.setValue}
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div
                              className="col-xs-12 col-sm-6 col-md-6 col-lg-4 m-b-15"
                              style={noMargin}
                            >
                              <BonzaTextField
                                title="Additional family riders (adults)"
                                type="number"
                                value={this.state.noOfAddAdult}
                                name="noOfAddAdult"
                                disabled= 'true'
                                // onChange={this.setValueOfAdultEquipments}
                              />
                            </div>
                            <div
                              className="col-xs-12 col-sm-6 col-md-6 col-lg-4 m-b-15"
                              style={noMargin}
                            >
                              <BonzaTextField
                                title="Additional rider rate ($)"
                                type="number"
                                value={this.state.additionalRate}
                                name="additionalRate"
                                disabled= 'true'
                                // onChange={this.setValue}
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div
                              className="col-xs-12 col-sm-12 col-md-12 col-lg-12 m-b-15"
                              style={noMargin}
                            >
                              <BonzaTextField
                                title="Additional family riders (children)"
                                type="number"
                                value={this.state.noOfAddChildren}
                                name="noOfAddChildren"
                                disabled= 'true'
                                // onChange={this.setValueOfKidEquipments}
                              />
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div>
                          <div className="row">
                            <div
                              className="col-xs-12 col-sm-6 col-md-6 col-lg-4 m-b-15"
                              style={noMargin}
                            >
                              <BonzaTextField
                                title="Number of adults"
                                type="number"
                                value={this.state.noOfAdult}
                                name="noOfAdult"
                                disabled= 'true'
                                // onChange={this.setValueOfAdultEquipments}
                              />
                            </div>
                            <div
                              className="col-xs-12 col-sm-6 col-md-6 col-lg-4 m-b-15"
                              style={noMargin}
                            >
                              <BonzaTextField
                                title="Adult price ($)"
                                type="number"
                                value={this.state.adultPrice}
                                name="adultPrice"
                                disabled= 'true'
                                // onChange={this.setValue}
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div
                              className="col-xs-12 col-sm-6 col-md-6 col-lg-4 m-b-15"
                              style={noMargin}
                            >
                              <BonzaTextField
                                title="Number of children"
                                type="number"
                                value={this.state.noOfChildren}
                                name="noOfChildren"
                                disabled= 'true'
                                // onChange={this.setValueOfKidEquipments}
                              />
                            </div>
                            <div
                              className="col-xs-12 col-sm-6 col-md-6 col-lg-4 m-b-15"
                              style={noMargin}
                            >
                              <BonzaTextField
                                title="Child price ($)"
                                type="number"
                                value={this.state.childPrice}
                                name="childPrice"
                                disabled= 'true'
                                // onChange={this.setValue}
                              />
                            </div>
                          </div>
                        </div>
                      )}

                      <div className="row">
                        <div
                          className="col-xs-12 col-sm-6 col-md-6 col-lg-4 m-b-15"
                          style={noMargin}
                        >
                          <BonzaTextField
                            title="Babies under 2"
                            type="number"
                            value={this.state.noOfBabies}
                            name="noOfBabies"
                            disabled= 'true'
                            // onChange={this.setValueOfInfantEquipments}
                          />
                        </div>
                        <div
                          className="col-xs-12 col-sm-6 col-md-6 col-lg-4 m-b-15"
                          style={noMargin}
                        >
                          <BonzaTextField
                            title="Total riders"
                            type="number"
                            value={this.state.totalRiders}
                            name="totalRiders"
                            disabled= 'true'
                            // onChange={this.setValue}
                          />
                        </div>
                      </div>
                </div>
              </ExpansionPanelDetails>
            </ExpansionPanel>


          <ExpansionPanel
            expanded={!this.state.addEquipmentSectionCollapsed}
            onChange={() => {
              this.togglePanel(`addEquipmentSectionCollapsed`);
            }}
          >
            <ExpansionPanelSummary
              expandIcon={<ExpandMoreIcon style={{ color: `white` }} />}
              style={panelHeaderStyle}
            >
              <div>
                <div style={{ float: `left`, paddingRight: `10px` }}>
                  <DirectionsBikeIcon />
                </div>{" "}
                Add Or Update Additional Equipment
              </div> 
            
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                        <div>
                            <TableBody>
                              <TableRow>
                                      <BonzaBooleanField
                                        title="Override Equipment Inventory"
                                        value={this.state.overrideEquipmentCount}
                                        name="overrideEquipmentCount"
                                        // disabled={this.state.locked ? true : false}
                                        onChange={this.resetEquipmentOverride}
                                      />
                                    <div className="row" style={{ display: "flex" }}>
                                        <div
                                          className="col-xs-12 col-sm-6 col-md-4 col-lg-3 m-b-15"
                                          style={noMargin}
                                        >
                                          <BonzaTextField
                                            title="e-Bikes Required"
                                            type="number"
                                            value={this.state.noOfEBikes}
                                            name="noOfEBikes"
                                            onChange={this.setValueOfAdultEquipments}
                                            disabled= {this.state.tourInActive}
                                          />
                                        </div>
                                        <div
                                          className="col-xs-12 col-sm-6 col-md-4 col-lg-3 m-b-15"
                                          style={noMargin}
                                        >
                                          <BonzaTextField
                                            title="e-Bikes Already Booked"
                                            type="number"
                                            value={this.state.noOfEBikesTour}
                                            name="noOfEBikesTour"
                                            disabled= 'true'
                                          />
                                        </div>
                                        <div
                                          className="col-xs-12 col-sm-6 col-md-4 col-lg-3 m-b-15"
                                          style={noMargin}
                                        >
                                          <BonzaTextField
                                            title="e-Bike Price ($)"
                                            type="number"
                                            value={this.state.eBikePrice}
                                            name="eBikePrice"
                                            disabled= {this.state.tourInActive}
                                            onChange={this.setValue}
                                          />
                                        </div>
                                        <div
                                          className="col-xs-12 col-sm-6 col-md-4 col-lg-3 m-b-15"
                                          style={noMargin}
                                        >
                                          <BonzaTextField
                                            title="Inventory Sold/Total Inventory"
                                            type="string"
                                            value={this.state.totalInventory['eBikeInventory'].totalBooked + `/` + 
                                                        this.state.totalInventory['eBikeInventory'].totalInventory}
                                            disabled= 'true'
                                            name="eBikeInventory"
                                          />
                                        </div>
                                      </div>
                              </TableRow>
                                <TableRow>
                                  
                                      <div className="row">
                                        <div
                                          className="col-xs-12 col-sm-6 col-md-4 col-lg-3 m-b-15"
                                          style={noMargin}
                                        >
                                          <BonzaTextField
                                            title="Baby Seats Required"
                                            type="number"
                                            value={this.state.noOfBabySeats}
                                            name="noOfBabySeats"
                                            onChange={this.setValueOfInfantEquipments}
                                            disabled= {this.state.tourInActive}
                                          />
                                        </div>
                                        <div
                                          className="col-xs-12 col-sm-6 col-md-4 col-lg-3 m-b-15"
                                          style={noMargin}
                                        >
                                          <BonzaTextField
                                            title="Baby Seats Already Booked"
                                            value={this.state.noOfBabySeatsTour}
                                            type="number"
                                            disabled= 'true'
                                            name="babaySeatsTour"
                                          />
                                        </div>
                                        <div
                                          className="col-xs-12 col-sm-6 col-md-4 col-lg-3 m-b-15"
                                          style={noMargin}
                                        >
                                          <BonzaTextField
                                            title="Baby Seat Price ($)"
                                            type="number"
                                            value={this.state.babySeatPrice}
                                            name="babySeatPrice"
                                            disabled= {this.state.tourInActive}
                                            onChange={this.setValue}
                                          />
                                        </div>
                                        <div
                                          className="col-xs-12 col-sm-6 col-md-4 col-lg-3 m-b-15"
                                          style={noMargin}
                                        >
                                          <BonzaTextField
                                            title="Inventory Sold/Total Inventory"
                                            type="string"
                                            value={this.state.totalInventory['babySeatInventory'].totalBooked + `/` + 
                                                        this.state.totalInventory['babySeatInventory'].totalInventory}
                                            disabled= 'true'
                                            name="babySeatInventory"
                                          />
                                        </div>
                                      </div>
                                </TableRow>
                                <TableRow>
                                      <div className="row">
                                        <div
                                          className="col-xs-12 col-sm-6 col-md-4 col-lg-3 m-b-15"
                                          style={noMargin}
                                        >
                                          <BonzaTextField
                                            title="Trail Alongs Required"
                                            type="number"
                                            value={this.state.noOfTrailAlongs}
                                            name="noOfTrailAlongs"
                                            onChange={this.setValueOfKidEquipments}
                                            disabled= {this.state.tourInActive}
                                          />
                                        </div>
                                        <div
                                          className="col-xs-12 col-sm-6 col-md-4 col-lg-3 m-b-15"
                                          style={noMargin}
                                        >
                                          <BonzaTextField
                                            title="Trail Alongs already Booked"
                                            type="number"
                                            value={this.state.noOfTrailAlongsTour}
                                            name="noOfTrailAlongsTour"
                                            disabled= 'true'
                                          />
                                        </div>
                                        <div
                                          className="col-xs-12 col-sm-6 col-md-4 col-lg-3 m-b-15"
                                          style={noMargin}
                                        >
                                          <BonzaTextField
                                            title="Trail Along Price ($)"
                                            type="number"
                                            value={this.state.trailAlongPrice}
                                            name="trailAlongPrice"
                                            disabled= {this.state.tourInActive}
                                            onChange={this.setValue}
                                          />
                                        </div>
                                        <div
                                          className="col-xs-12 col-sm-6 col-md-4 col-lg-3 m-b-15"
                                          style={noMargin}
                                        >
                                          <BonzaTextField
                                            title="Inventory Sold/Total Inventory"
                                            type="string"
                                            value={this.state.totalInventory['trailAlongInventory'].totalBooked + `/` + 
                                                        this.state.totalInventory['trailAlongInventory'].totalInventory}
                                            disabled= 'true'
                                            name="traiAlongInventory"
                                          />
                                        </div>
                                      </div>
                                </TableRow>
                                <TableRow>
                                      <div className="row">
                                        <div
                                          className="col-xs-12 col-sm-6 col-md-4 col-lg-3 m-b-15"
                                          style={noMargin}
                                        >
                                          <BonzaTextField
                                            title="Kiddie Carriers Required"
                                            type="number"
                                            value={this.state.noOfKiddieCarriers}
                                            name="noOfKiddieCarriers"
                                            onChange={this.setValueOfKidEquipments}
                                            disabled= {this.state.tourInActive}
                                          />
                                        </div>
                                        <div
                                          className="col-xs-12 col-sm-6 col-md-4 col-lg-3 m-b-15"
                                          style={noMargin}
                                        >
                                          <BonzaTextField
                                            title="Kiddie Carriers already Booked"
                                            type="number"
                                            value={this.state.noOfKiddieCarriersTour}
                                            name="noOfKiddieCarriersTour"
                                            disabled= 'true'
                                          />
                                        </div>
                                        <div
                                          className="col-xs-12 col-sm-6 col-md-4 col-lg-3 m-b-15"
                                          style={noMargin}
                                        >
                                          <BonzaTextField
                                            title="Kiddie Carrier Price ($)"
                                            type="number"
                                            value={this.state.kiddieCarrierPrice}
                                            name="kiddieCarrierPrice"
                                            disabled= {this.state.tourInActive}
                                            onChange={this.setValue}
                                          />
                                        </div>
                                        <div
                                          className="col-xs-12 col-sm-6 col-md-4 col-lg-3 m-b-15"
                                          style={noMargin}
                                        >
                                          <BonzaTextField
                                            title="Inventory Sold/Total Inventory"
                                            type="string"
                                            value={this.state.totalInventory['kiddieCarrierInventory'].totalBooked + `/` + 
                                                        this.state.totalInventory['kiddieCarrierInventory'].totalInventory}
                                            disabled= 'true'
                                            name="kiddieCarrierInventory"
                                          />
                                        </div>
                                      </div>
                                </TableRow>
                                <TableRow>
                                      <div className="row">
                                        <div
                                          className="col-xs-12 col-sm-6 col-md-4 col-lg-3 m-b-15"
                                          style={noMargin}
                                        >
                                          <BonzaTextField
                                            title="Small Kids Bikes Required"
                                            type="number"
                                            value={this.state.noOfSmallKidsBikes}
                                            name="noOfSmallKidsBikes"
                                            onChange={this.setValueOfKidEquipments}
                                            disabled= {this.state.tourInActive}
                                          />
                                        </div>
                                        <div
                                          className="col-xs-12 col-sm-6 col-md-4 col-lg-3 m-b-15"
                                          style={noMargin}
                                        >
                                          <BonzaTextField
                                            title="Small Kids Bikes already Booked"
                                            type="number"
                                            value={this.state.noOfSmallKidsBikesTour}
                                            name="noOfSmallKidsBikesTour"
                                            disabled= 'true'
                                          />
                                        </div>
                                        <div
                                          className="col-xs-12 col-sm-6 col-md-4 col-lg-3 m-b-15"
                                          style={noMargin}
                                        >
                                          <BonzaTextField
                                            title="Small Kids Bike Price ($)"
                                            type="number"
                                            value={this.state.smallKidsBikePrice}
                                            name="smallKidsBikePrice"
                                            disabled= {this.state.tourInActive}
                                            onChange={this.setValue}
                                          />
                                        </div>
                                        <div
                                          className="col-xs-12 col-sm-6 col-md-4 col-lg-3 m-b-15"
                                          style={noMargin}
                                        >
                                          <BonzaTextField
                                            title="Inventory Sold/Total Inventory"
                                            type="string"
                                            value={this.state.totalInventory['smallKidsBikeInventory'].totalBooked + `/` + 
                                                    this.state.totalInventory['smallKidsBikeInventory'].totalInventory}
                                            name="smallKidsBikeInventory"
                                            disabled= 'true'
                                          />
                                        </div>
                                      </div>
                                </TableRow>
                                <TableRow>
                                      <div className="row">
                                        <div
                                          className="col-xs-12 col-sm-6 col-md-4 col-lg-3 m-b-15"
                                          style={noMargin}
                                        >
                                          <BonzaTextField
                                            title="Large Kids Bikes Required"
                                            type="number"
                                            value={this.state.noOfLargeKidsBikes}
                                            name="noOfLargeKidsBikes"
                                            onChange={this.setValueOfKidEquipments}
                                            disabled= {this.state.tourInActive}
                                          />
                                        </div>
                                        <div
                                          className="col-xs-12 col-sm-6 col-md-4 col-lg-3 m-b-15"
                                          style={noMargin}
                                        >
                                          <BonzaTextField
                                            title="Large Kids Bikes already Booked"
                                            type="number"
                                            value={this.state.noOfLargeKidsBikesTour}
                                            name="noOfLargeKidsBikesTour"
                                            disabled= 'true'
                                          />
                                        </div>
                                        <div
                                          className="col-xs-12 col-sm-6 col-md-4 col-lg-3 m-b-15"
                                          style={noMargin}
                                        >
                                          <BonzaTextField
                                            title="Large Kids Bike Price ($)"
                                            type="number"
                                            value={this.state.largeKidsBikePrice}
                                            name="largeKidsBikePrice"
                                            disabled= {this.state.tourInActive}
                                            onChange={this.setValue}
                                          />
                                        </div>
                                        <div
                                          className="col-xs-12 col-sm-6 col-md-4 col-lg-3 m-b-15"
                                          style={noMargin}
                                        >
                                          <BonzaTextField
                                            title="Inventory Sold/Total Inventory"
                                            type="string"
                                            value={this.state.totalInventory['largeKidsBikeInventory'].totalBooked + `/` + 
                                                          this.state.totalInventory['largeKidsBikeInventory'].totalInventory}
                                            disabled= 'true'
                                            name="largeKidsBikeInventory"
                                          />
                                        </div>
                                      </div>
                                  </TableRow>
                                </TableBody>
                          </div>
                        </ExpansionPanelDetails>
                      </ExpansionPanel>
                
                
                  {this.state.equipmentPurchaseID > 0 ? (
                    <div style={{ paddingBottom: `10px` }}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.onFormSubmit}
                        disabled= {this.state.tourInActive}
                      >
                        Update purchase
                      </Button>
                      {
                        this.state.tourInActive ?  ( <Button variant="contained" style={{marginLeft: '10px'}}
                        disabled= {this.state.tourInActive} >Add payment</Button>) : 
                          (<Link
                          to={`/purchases/${this.state.equipmentPurchaseID}/payment`}
                          className="no-underline"
                          style={{ paddingLeft: `10px`}}
                        >
                          <Button variant="contained"
                          disabled= {this.state.tourInActive}
                          >Add payment</Button>
                        </Link>)
                      }
                      {this.state.tourInActive ?  ( <Button variant="contained" style={{marginLeft: '10px'}}
                      disabled= {this.state.tourInActive} >Add refund</Button>) :
                        (<Link
                          to={`/purchases/${this.state.equipmentPurchaseID}/refund`}
                          className="no-underline"
                          style={{ paddingLeft: `10px` }}
                        >
                          <Button variant="contained" 
                          disabled= {this.state.tourInActive}>Add refund</Button>
                        </Link>)
                      }
                      { this.state.tourInActive ?  ( <Button variant="contained" style={{marginLeft: '10px'}}
                      disabled= {this.state.tourInActive} >Payment history</Button>) : 
                        (<Link
                          to={`/purchases/${this.state.equipmentPurchaseID}/history`}
                          className="no-underline"
                          style={{ paddingLeft: `10px` }}
                        >
                          <Button variant="contained" 
                          disabled= {this.state.tourInActive}>Payment history</Button>
                        </Link>
                        ) 
                      }
                      <Button
                        variant="contained"
                        color="secondary"
                        style={{ marginLeft: `10px` }}
                        onClick={this.onDeleteEquipmentPurchase}
                        disabled= {!this.state.allowDelete}
                      >
                        DELETE
                      </Button>
                    </div>
                  ) : (
                    <div>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.onFormSubmit}
                        disabled= {this.state.tourInActive}
                      >
                        Save
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.onFormSubmitAndTakePayment}
                        style={{ paddingLeft: `10px`, marginLeft: `10px` }}
                        disabled= {this.state.tourInActive}
                      >
                        Save and take payment
                      </Button>
                    </div>
                  )}
                </div>
            ) : (
              false
            )}
        </div>
        
        
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          open={this.state.validationErrors.length > 0}
          autoHideDuration={6000}
          onClose={this.handleClose}
          ContentProps={{
            "aria-describedby": "message-id",
          }}
          message={
            <div>
              {this.state.validationErrors.map((item, index) => (
                <p key={`error_message_${index}`}>{item}</p>
              ))}
            </div>
          }
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={this.handleClose}
            >
              <CloseIcon />
            </IconButton>,
          ]}
        />
      </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    addPurchaseReducer,
    customerReducer,
    userReducer,
    productReducer,
    auth,
  } = state;
  const { loading, error, purchase } = addPurchaseReducer;
  const { customers, customerComission } = customerReducer;
  const { tourPricing, products, purchasePriceUpdating, purchasePriceUpdated } =
    productReducer;
  const { users } = userReducer;
  const { user } = auth;
  return {
    loading,
    error,
    purchase,
    products,
    customers,
    customerComission,
    tourPricing,
    users,
    user,
    purchasePriceUpdating,
    purchasePriceUpdated,
  };
}

EquipmentPurchasePage.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

export default withStyles(styles)(
  connect(mapStateToProps)(EquipmentPurchasePage),
);



/** WEBPACK FOOTER **
 ** ./src/containers/EquipmentPurchasePage.js
 **/